import React from 'react';

import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Col from 'reactstrap/lib/Col';
import Row from 'reactstrap/lib/Row';

import { Container } from '@ttstr/components';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Container fluid>
      <Row className="mt-3 mb-3 d-flex align-items-center">
        <Col md="12" className="align-items-center d-flex justify-content-center mt-4 text-center text-muted copyright">
          <p className="mb-5">
            &copy; <a href="https://www.fettesbrot.de">FETTES BROT</a>
            <br />
            <small>
              <b>powered by <a href="https://www.teamtoaster.de">teamtoaster – we are direct-to-fan</a></b>
            </small>
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default React.memo(Footer);
